<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let title;
</script>

<div class="modal-title">
    <h1>{title}</h1>
    <a href={"#"} class="close1" on:click={() => dispatch("close")}> </a>
</div>

<style>
    .modal-title {
        margin: 1rem 0 0.5rem 1rem;
    }
    h1 {
        color: #242424;
        font-weight: 500;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
        font-size: large;
        padding-bottom: 0.5rem;
        border-bottom: 0.5px solid #ddd;
    }
    .close1 {
        position: absolute;
        right: 24px;
        top: 12px;
        width: 24px;
        height: 24px;
        opacity: 0.3;
    }
    .close1:hover {
        opacity: 1;
    }
    .close1:before,
    .close1:after {
        position: absolute;
        left: 15px;
        content: " ";
        height: 25px;
        width: 2px;
        background-color: #333;
    }
    .close1:before {
        transform: rotate(45deg);
    }
    .close1:after {
        transform: rotate(-45deg);
    }
</style>
